import LeftNavigation from './LeftNavigation.container';

export default LeftNavigation;